import { describe, expect, it } from 'vitest';

import { CARD_CATEGORIES } from '../../../../../../../shared/cardConfig/constants';
import {
  ATTACHMENT_FIELDS,
  DELIVERY_DETAILS_FIELDS,
  DELIVERY_INSTRUCTIONS_FIELDS,
  SHIP_TO_ADDRESS_FIELDS
} from '../../../../../../../shared/fieldConfig/constants';
import { PAGE_ROUTES } from '../../../../../../../utils/constants';
import pages, { type Card, type Field, type Page } from '..';

describe('ShipTo Page Template', () => {
  it('exports one page', () => {
    expect(Array.isArray(pages)).toBe(true);
    expect(pages).toHaveLength(1);
  });

  const shipToPage = pages.find(page => page.route === PAGE_ROUTES.shipTo) as Page;

  describe('ShipTo Page Structure', () => {
    it('has correct route', () => {
      expect(shipToPage).toBeDefined();
      expect(shipToPage.route).toBe(PAGE_ROUTES.shipTo);
    });

    it('contains expected cards', () => {
      expect(Array.isArray(shipToPage.cards)).toBe(true);
      expect(shipToPage.cards).toHaveLength(5);
    });
  });

  describe('Address Card', () => {
    const addressCard = shipToPage.cards!.find(
      card => card.key === CARD_CATEGORIES.address
    ) as Card;

    it('has hideSameAs enabled', () => {
      expect(addressCard).toBeDefined();
      expect(addressCard.hideSameAs).toBe(true);
    });

    it('has correct fields', () => {
      expect(addressCard.fields?.map((f: Field) => f.key)).toEqual([
        SHIP_TO_ADDRESS_FIELDS.address,
        SHIP_TO_ADDRESS_FIELDS.taxNumber2,
        SHIP_TO_ADDRESS_FIELDS.taxNumber3
      ]);
    });

    it('has correct fieldWrapper', () => {
      expect(addressCard.fieldWrapper).toBe(CARD_CATEGORIES.shipTo);
    });
  });

  describe('Delivery Details Card', () => {
    const deliveryDetailsCard = shipToPage.cards!.find(
      card => card.key === CARD_CATEGORIES.deliveryDetails
    ) as Card;

    it('contains expected delivery fields', () => {
      expect(deliveryDetailsCard.fields?.map((f: Field) => f.key)).toEqual([
        DELIVERY_DETAILS_FIELDS.appointmentRequired,
        DELIVERY_DETAILS_FIELDS.receivingPlantContactName,
        DELIVERY_DETAILS_FIELDS.receivingPlantPhoneNumber,
        DELIVERY_DETAILS_FIELDS.afterHoursContactName,
        DELIVERY_DETAILS_FIELDS.afterHoursPhoneNumber,
        DELIVERY_DETAILS_FIELDS.warehouseReceivingHours
      ]);
    });
  });

  describe('Delivery Instructions Card', () => {
    const deliveryInstructionsCard = shipToPage.cards!.find(
      card => card.key === CARD_CATEGORIES.deliveryInstructions
    ) as Card;

    it('contains expected instruction fields', () => {
      expect(deliveryInstructionsCard.fields?.map((f: Field) => f.key)).toEqual([
        DELIVERY_INSTRUCTIONS_FIELDS.shippingInstructions,
        DELIVERY_INSTRUCTIONS_FIELDS.shippingMarks,
        DELIVERY_INSTRUCTIONS_FIELDS.customsText,
        DELIVERY_INSTRUCTIONS_FIELDS.loadingInstructions,
        DELIVERY_INSTRUCTIONS_FIELDS.unloadingInstructions,
        DELIVERY_INSTRUCTIONS_FIELDS.packingInstructions,
        DELIVERY_INSTRUCTIONS_FIELDS.billOfLadingText,
        DELIVERY_INSTRUCTIONS_FIELDS.textNotaFiscal
      ]);
    });
  });

  describe('Attachment & Privacy Cards', () => {
    it('contains additionalAttachmentCard', () => {
      const attachmentCard = shipToPage.cards!.find(
        card => card.key === CARD_CATEGORIES.additionalAttachmentCard
      ) as Card;

      expect(attachmentCard).toBeDefined();
      expect(attachmentCard.fields?.[0].key).toBe(ATTACHMENT_FIELDS.additionalAttachment);
    });

    it('contains privacyPolicy card without fields', () => {
      const privacyCard = shipToPage.cards!.find(
        card => card.key === CARD_CATEGORIES.privacyPolicy
      ) as Card;

      expect(privacyCard).toBeDefined();
      expect(privacyCard.fields).toBeUndefined();
    });
  });
});
